import React from "react";
import { Box, Button, Chip, Stack, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Fonts } from "shared/constants/AppEnums";
import { CustomerMasterData } from "types/models/customerMaster/CustomerMasterApp";
import { useNavigate } from "react-router";
import { isModuleAuthorized } from "@crema/utility/Utils";

interface Props {
  customer: CustomerMasterData;
  currentCustomer?: any;

  showHeaderActions?: boolean;
  onResendSms?: () => void;
  onRefresh?: () => void;
  onAddNew?: () => void;
}

const CustomerCreateHeader: React.FC<Props> = ({
  customer,
  currentCustomer,
  showHeaderActions = false,
  onResendSms,
  onRefresh,
  onAddNew,
}) => {
  const navigate = useNavigate();

  const handleBackClick = () => navigate("/customerCare/list");

  const leadId = currentCustomer?.customer_care_id || "";
  const feasibility = currentCustomer?.feasibility || "";
  const latLong = currentCustomer?.latLong || currentCustomer?.lat_long || "";
  const mapAddress = currentCustomer?.map_address || "";
  const feasibilityRaw = (currentCustomer?.feasibility || "").toString().trim().toUpperCase();
const feasibilityUI = (() => {
  if (feasibilityRaw === "N") {
    return {
      text: "Broadband service is not available at this location",
      sx: { color: "error.main", borderColor: "error.main", backgroundColor: "error.lighter" },
    };
  }
  if (feasibilityRaw === "Y") {
    return {
      text: "Please advise customer that broadband service is available at this location",
      sx: { color: "success.main", borderColor: "success.main", backgroundColor: "success.lighter" },
    };
  }
  if (feasibilityRaw === "P") {
    return {
      text: "Address partially verified. Ground team verification required",
      sx: { color: "warning.main", borderColor: "warning.main", backgroundColor: "warning.lighter" },
    };
  }
  return null;
})();
  return (
    <Box sx={{ borderBottom: "1px solid #E5E4EA", pb: 2, mb: 2 }}>
      {/* Title row */}
      <Box
        sx={{
          display: "flex",
          alignItems: { xs: "flex-start", sm: "center" },
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: "space-between",
          gap: 2,
          width: "100%",
          mb: 1.5,
          pt: 1.5,
          pb: 1.5,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          {isModuleAuthorized("View CC Lead") && (
            <Button
              startIcon={<ArrowBackIcon />}
              onClick={handleBackClick}
              sx={{ textTransform: "none", color: "black", p: 0, minWidth: "auto" }}
            />
          )}

          <Box
            component="h3"
            sx={{
              color: "text.primary",
              fontWeight: Fonts.BOLD,
              fontSize: 16,
              ml: 0.5,
              mb: 0,
            }}
          >
            {customer.PageID ? "Edit cc lead" : "Add cc lead"}
          </Box>
        </Box>
        {showHeaderActions && (
        <Box
            sx={{
              display: "flex",
              gap: 1.5,
              justifyContent: { xs: "flex-start", md: "flex-end" },
              width: { xs: "100%", md: "auto" },
              flexWrap: "wrap",
            }}
          >
            <Button variant="outlined" color="secondary" onClick={onResendSms}>
              Resend SMS
            </Button>

            <Button variant="contained" color="primary" onClick={onRefresh}>
              Refresh
            </Button>

            <Button variant="outlined" color="primary" onClick={onAddNew}>
              Add New CC Lead
            </Button>
          </Box>
           )}
      </Box>
       {showHeaderActions && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: { xs: "flex-start", md: "center" },
            flexDirection: { xs: "column", md: "row" },
            gap: 1.5,
            width: "100%",
          }}
        >
              {feasibilityUI && (
        <Box
          sx={{
            mt: 1,
            px: 1.5,
            py: 1,
            borderRadius: 1,
            border: "1px solid",
            fontSize: 13,
            fontWeight: 600,
            ...feasibilityUI.sx,
          }}
        >
          {feasibilityUI.text}
        </Box>
      )}
        </Box>
      )}
    </Box>
  );
};

export default CustomerCreateHeader;
